import { render, staticRenderFns } from "./Institucion.vue?vue&type=template&id=994dff92&scoped=true&lang=pug&"
import script from "./Institucion.vue?vue&type=script&lang=js&"
export * from "./Institucion.vue?vue&type=script&lang=js&"
import style0 from "./Institucion.vue?vue&type=style&index=0&id=994dff92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994dff92",
  null
  
)

export default component.exports